export const categoryHubData = {
  title: "今日大瓜",
  subtitle: "全网最新爆料 · 实时追踪",
  description: "三大频道每日更新，网红翻车、反差视频、酒店猛料，你想吃的瓜这里都有。资深吃瓜群众的24小时不打烊专属基地。",
  categories: [
    {
      slug: "wanghong",
      name: "网红翻车现场",
      tag: "最热频道",
      desc: "素人网红人设崩塌全记录，从爆红到翻车只在一瞬间",
      icon: "ri-user-unfollow-line",
      color: "primary",
      count: "1,286条",
      image: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20spotlight%20fading%2C%20empty%20microphone%20stand%2C%20fallen%20confetti%20on%20dark%20floor%2C%20warm%20amber%20atmospheric%20lighting%2C%20cinematic%20composition%2C%20conceptual%20photography%2C%20deep%20shadows&width=800&height=600&seq=hub-cat-wanghong&orientation=landscape",
    },
    {
      slug: "fancha",
      name: "反差视频精选",
      tag: "每日更新",
      desc: "台前幕后巨大反差，揭开光鲜亮丽背后的真实面目",
      icon: "ri-contrast-2-line",
      color: "accent",
      count: "958条",
      image: "https://readdy.ai/api/search-image?query=Split%20screen%20dramatic%20concept%2C%20left%20side%20bright%20glamor%2C%20right%20side%20dark%20shadow%2C%20contrasting%20scenes%2C%20cinematic%20lighting%2C%20teal%20and%20warm%20tone%2C%20editorial%20photography%2C%20mysterious%20atmosphere&width=800&height=600&seq=hub-cat-fancha&orientation=landscape",
    },
    {
      slug: "jiudian",
      name: "酒店猛料曝光",
      tag: "独家内幕",
      desc: "娱乐圈不为人知的秘密约会与行业内幕，每日震撼更新",
      icon: "ri-hotel-line",
      color: "secondary",
      count: "647条",
      image: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20dim%20warm%20lighting%2C%20slightly%20open%20door%2C%20mysterious%20atmosphere%2C%20noir%20cinematic%20style%2C%20deep%20shadows%2C%20amber%20and%20rose%20gold%20tones%2C%20editorial%20photography&width=800&height=600&seq=hub-cat-jiudian&orientation=landscape",
    },
  ],
  latestArticles: [
    {
      id: "latest-1",
      title: "知名带货主播直播间现场翻车，背后资本运作链条遭深扒",
      category: "网红翻车",
      time: "2小时前",
      image: "https://readdy.ai/api/search-image?query=Dark%20studio%20with%20single%20spotlight%20on%20empty%20streaming%20setup%2C%20ring%20light%20off%2C%20dramatic%20shadows%2C%20minimalist%20dark%20background%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere&width=600&height=400&seq=hub-latest-01&orientation=landscape",
    },
    {
      id: "latest-2",
      title: "豪门恋情大反转，五星酒店密会视频流出引发全网热议",
      category: "酒店猛料",
      time: "5小时前",
      image: "https://readdy.ai/api/search-image?query=Elegant%20hotel%20suite%20curtains%20drawn%2C%20city%20lights%20through%20window%2C%20dim%20ambient%20lighting%2C%20empty%20armchair%20and%20wine%20glass%2C%20mysterious%20romantic%20atmosphere%2C%20film%20noir%20style&width=600&height=400&seq=hub-latest-02&orientation=landscape",
    },
    {
      id: "latest-3",
      title: "素人网红清纯人设崩塌，私下混乱生活证据遭全面曝光",
      category: "反差视频",
      time: "8小时前",
      image: "https://readdy.ai/api/search-image?query=Broken%20mirror%20reflecting%20fragmented%20faces%2C%20dark%20room%20scattered%20photos%2C%20dramatic%20side%20lighting%2C%20conceptual%20art%20style%2C%20warm%20amber%20lamp%20light&width=600&height=400&seq=hub-latest-03&orientation=landscape",
    },
    {
      id: "latest-4",
      title: "娱乐圈幕后大佬聚会照曝光，错综复杂关系网浮出水面",
      category: "网红翻车",
      time: "12小时前",
      image: "https://readdy.ai/api/search-image?query=Dark%20private%20dining%20room%20long%20empty%20table%2C%20half-finished%20wine%20glasses%2C%20dim%20chandelier%2C%20luxurious%20abandoned%20setting%2C%20noir%20cinematic%20style&width=600&height=400&seq=hub-latest-04&orientation=landscape",
    },
    {
      id: "latest-5",
      title: "顶流明星深夜出入酒店被拍，新恋情疑似浮出水面",
      category: "酒店猛料",
      time: "16小时前",
      image: "https://readdy.ai/api/search-image?query=Empty%20airport%20terminal%20at%20night%2C%20long%20corridor%20dim%20lights%2C%20reflection%20on%20polished%20floor%2C%20atmospheric%20mysterious%2C%20cinematic%20composition&width=600&height=400&seq=hub-latest-05&orientation=landscape",
    },
    {
      id: "latest-6",
      title: "选秀节目后台不雅视频流出，节目组紧急发声明澄清",
      category: "反差视频",
      time: "20小时前",
      image: "https://readdy.ai/api/search-image?query=Dark%20backstage%20area%20with%20costume%20racks%2C%20dim%20backlight%2C%20scattered%20props%2C%20empty%20dressing%20room%20mirror%2C%20mysterious%20atmosphere%2C%20theater%20backstage%20noir&width=600&height=400&seq=hub-latest-06&orientation=landscape",
    },
  ],
};

// 网红翻车频道
export const wanghongData = {
  title: "网红翻车现场",
  subtitle: "素人网红人设崩塌全记录",
  description: "第一手网红翻车内幕，从百万粉丝到人设崩塌，每一次翻车都震撼你的眼球。本频道24小时追踪网红圈最新丑闻与争议事件，还原最真实的网红生态。",
  heroImage: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20spotlight%20crashing%20down%2C%20shattered%20glass%20effects%2C%20smoke%20and%20debris%2C%20warm%20orange%20and%20deep%20shadow%2C%20cinematic%20destruction%20scene%2C%20conceptual%20photography%2C%20intense%20dramatic%20mood&width=1920&height=800&seq=wanghong-hero-01&orientation=landscape",
  featuredArticle: {
    title: "百万粉丝美妆博主被扒黑历史，品牌方集体解约",
    time: "1小时前",
    image: "https://readdy.ai/api/search-image?query=Makeup%20products%20scattered%20on%20dark%20vanity%20table%2C%20cracked%20mirror%2C%20dim%20dramatic%20lighting%2C%20abandoned%20beauty%20studio%2C%20warm%20atmospheric%20mood%2C%20editorial%20photography%2C%20deep%20shadows&width=800&height=1000&seq=wanghong-featured-01&orientation=portrait",
    excerpt: "曾凭借一手精湛化妆技术吸粉百万的美妆博主@甜心美妆酱，近日被同行曝光其早期视频造假、产品测评收钱推广不标注等一系列黑料。多个知名美妆品牌紧急宣布终止合作，其社交账号一夜掉粉30万。",
  },
  articles: [
    { id: "wh-1", title: "搞笑段子手人设崩塌，私信骚扰多名女粉丝被曝光", time: "3小时前", views: "12.8万" },
    { id: "wh-2", title: "健身博主被揭使用特效滤镜造假身材，真实照片流出", time: "6小时前", views: "9.5万" },
    { id: "wh-3", title: "母婴博主虐待儿童传闻引众怒，警方已介入调查", time: "9小时前", views: "28.3万" },
    { id: "wh-4", title: "美食博主被曝后厨卫生堪忧，粉丝集体退款", time: "14小时前", views: "15.6万" },
    { id: "wh-5", title: "旅行博主造假打卡地点，PS痕迹被细心网友扒出", time: "18小时前", views: "7.2万" },
    { id: "wh-6", title: "知识付费大V学历造假，985名校背景纯属虚构", time: "22小时前", views: "33.1万" },
    { id: "wh-7", title: "穿搭博主抄袭被原创设计师集体声讨，道歉视频翻车", time: "1天前", views: "11.4万" },
    { id: "wh-8", title: "宠物博主被指虐待动物获取流量，动保组织介入", time: "1天前", views: "19.8万" },
  ],
};

// 反差视频频道
export const fanchaData = {
  title: "反差视频精选",
  subtitle: "台前幕后 · 天壤之别",
  description: "镜头前的光鲜亮丽与镜头后的真实模样，反差大到让你怀疑人生。本频道精选全网反差视频，揭开网红名人的真实面目，每一帧都是你想象不到的震撼。",
  heroImage: "https://readdy.ai/api/search-image?query=Split%20face%20dramatic%20concept%2C%20left%20half%20bright%20glamorous%20studio%20light%2C%20right%20half%20dark%20shadowy%20backstage%2C%20contrasting%20scenes%2C%20cinematic%20composition%2C%20teal%20and%20warm%20split%20tone%2C%20editorial%20photography&width=1920&height=800&seq=fancha-hero-01&orientation=landscape",
  featuredArticle: {
    title: "清纯女神深夜酒吧视频曝光，与白天判若两人",
    time: "4小时前",
    image: "https://readdy.ai/api/search-image?query=Two%20contrasting%20scenes%20split%20diagonally%2C%20upper%20bright%20day%20garden%20peaceful%2C%20lower%20dark%20nightclub%20neon%20lights%2C%20conceptual%20duality%20photography%2C%20dramatic%20contrast&width=800&height=1000&seq=fancha-featured-01&orientation=portrait",
    excerpt: "以清纯甜美形象走红的小花旦@纯纯兔兔，白天直播时温柔可人岁月静好，却被拍到深夜在酒吧与多名男性亲密互动，与平日形象截然不同。粉丝直呼：这反差也太大了吧！",
  },
  articles: [
    { id: "fc-1", title: "正能量博主私下脏话连篇，直播忘关麦全录下来了", time: "2小时前", views: "25.6万" },
    { id: "fc-2", title: "节俭人设博主豪宅曝光，月租18万的顶层公寓引争议", time: "5小时前", views: "18.9万" },
    { id: "fc-3", title: "学霸博主考试作弊被抓，985名校身份遭质疑", time: "7小时前", views: "32.1万" },
    { id: "fc-4", title: "素食主义博主被拍吃烤肉，多年人设一夜崩塌", time: "11小时前", views: "21.4万" },
    { id: "fc-5", title: "单身人设男博主隐婚生子，妻子发文实锤曝光", time: "15小时前", views: "45.7万" },
    { id: "fc-6", title: "爱国博主被扒持有外国护照，双面人言论遭炮轰", time: "19小时前", views: "38.2万" },
    { id: "fc-7", title: "公益博主善款去向不明，受助者称从未收到捐赠", time: "1天前", views: "27.3万" },
    { id: "fc-8", title: "独立女性人设崩塌，私下靠金主资助维持奢侈生活", time: "1天前", views: "16.8万" },
  ],
};

// 酒店猛料频道
export const jiudianData = {
  title: "酒店猛料曝光",
  subtitle: "娱乐圈不为人知的秘密",
  description: "锁定娱乐圈最隐秘的角落——酒店。从明星密会到行业内幕交易，每一次酒店曝光都揭开一段不为人知的故事。本频道独家追踪娱乐圈酒店猛料，让你看清光鲜背后的真相。",
  heroImage: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20at%20night%20with%20dramatic%20lighting%2C%20rain-soaked%20street%20reflections%2C%20mysterious%20atmosphere%2C%20film%20noir%20cinematic%20style%2C%20amber%20and%20deep%20shadow%2C%20urban%20night%20scene&width=1920&height=800&seq=jiudian-hero-01&orientation=landscape",
  featuredArticle: {
    title: "知名导演与女演员酒店密会48小时，实锤照片首曝光",
    time: "2小时前",
    image: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20room%20door%20slightly%20open%2C%20warm%20light%20spilling%20into%20dark%20corridor%2C%20room%20service%20tray%20outside%2C%20mysterious%20romantic%20atmosphere%2C%20noir%20style%2C%20deep%20shadows&width=800&height=1000&seq=jiudian-featured-01&orientation=portrait",
    excerpt: "据前线吃瓜记者独家拍摄，某知名导演与旗下女演员在某五星级酒店连续密会长达48小时。期间二人多次同进同出，举止亲密。消息人士透露，该导演正在筹备的新戏女主角已内定该演员，引发剧组其他成员不满。",
  },
  articles: [
    { id: "jd-1", title: "顶流小生与经纪人酒店开房被拍，回应称只是对剧本", time: "1小时前", views: "56.3万" },
    { id: "jd-2", title: "豪门千金婚前单身派对酒店狂欢，画面尺度惊人", time: "3小时前", views: "42.1万" },
    { id: "jd-3", title: "选角导演酒店房间面试女演员，业内人士曝潜规则内幕", time: "6小时前", views: "38.7万" },
    { id: "jd-4", title: "双料影帝酒店密会已婚女星，窗帘忘拉被拍个正着", time: "10小时前", views: "89.2万" },
    { id: "jd-5", title: "某卫视主持人酒店Party场面混乱，多人衣衫不整", time: "13小时前", views: "31.5万" },
    { id: "jd-6", title: "音乐制作人与女歌手酒店过夜，次日新歌榜单登顶", time: "17小时前", views: "27.8万" },
    { id: "jd-7", title: "富二代酒店包场追星，一晚消费金额令人咋舌", time: "21小时前", views: "19.4万" },
    { id: "jd-8", title: "国际电影节酒店后台，中外明星私下互动全记录", time: "1天前", views: "23.6万" },
  ],
};